<template>
	<div class="Box">
		<el-dialog width="45%" :close-on-click-modal="false" title="定价" :visible.sync="MoneyVisible" :before-close="handleClose">
			<el-form :model="EditFrom" size="medium" label-width="80px" class="mt35" :rules="rules" ref="ruleForm" >
					<el-row :gutter="35" class="center-content">
						<el-col :xs="24" :sm="12" :md="8" :lg="18" :xl="20" class="mb20">
							<el-form-item label="单集价格" prop="o_episode_price">
								<div class="input-with-pcenter" style="display: flex;">
									<el-input v-model.number="EditFrom.o_episode_price" placeholder="请输入单集价格"
										clearable style="width: 60%;"></el-input>
									<p class="pcenter">单集价格范围</p>
								</div>
							</el-form-item>
						</el-col>
						<el-col :xs="24" :sm="12" :md="8" :lg="18" :xl="20" class="mb20">
							<el-form-item label="免费集数" prop="o_free_episode">
								<div class="input-with-pcenter" style="display: flex;">
									<el-input v-model.number="EditFrom.o_free_episode" placeholder="请输入免费集数"
										clearable style="width: 60%;"></el-input>
									<p class="pcenter">免费集数范围</p>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="AddNone">取 消</el-button>
				<el-button type="primary" @click="addPush">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// import { channelNumberAPI } from '@/api/popularize/channelNumber';
export default {
	props: ['MoneyVisible',"MoneyObj"],
	components: {},
	data() {
		return {
			EditFrom: {
				o_episode_price: '',
				o_free_episode: '',
				movies_id: ""
           
			},
            edObj:{},
			rules: {
				// recharge_template_id: [{ required: true, message: '请选择充值模版', trigger: 'change' }],
				// status: [{ required: true, message: '请选择状态', trigger: 'change' }],
				// owner: [{ required: true, message: '请输入负责人', trigger: 'blur' }],
			},
		};
	},
	methods: {
		AddNone() {
			this.$emit('NoneMoney');
		},
        addPush(){
            
        },
		handleClose() {
			this.$emit('NoneMoney');
		},
	},
	created() {},
	mounted() {
        this.edObj=this.MoneyObj
	},
};
</script>
<style lang="scss" scoped>
.Box {
	& ::v-deep el-card__body {
		padding: 0 !important;
	}
}

.center-content {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
}

.center-content .el-col {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
</style>
